module.exports = __webpack_public_path__ + "img/CALENDER.5c80481d.svg";